// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2TJKS","ball":"styles_ball__3JxGW","ball-fall":"styles_ball-fall__3HqAT"};